export const VERSION_RELEASE_WEB_BRIDGE_NOTIFY_LOGIN_ERROR = '1.14.0';
export const VERSION_RELEASE_IOS_ACCOUNT_DELETION = '6.1.0';
export const VERSION_RELEASE_ANDROID_ACCOUNT_DELETION = '6.96.0';
export const VERSION_RELEASE_IOS_ANDROID_ACCOUNT_DELETION_VN = '12.27.0';
export const VERSION_RELEASE_ANDROID_WEB_BRIDGE_DFP = '6.43.0';
export const VERSION_RELEASE_ANDROID_WEB_BRIDGE_DFP_VN = '12.2.0';
export const VERSION_RELEASE_CHANGE_PHONE = '6.99.3';
export const VERSION_RELEASE_CHANGE_EMAIL_DEFAULT = '7.20.0';
export const VERSION_RELEASE_CHANGE_EMAIL_VN = '12.44.0';
export const VERSION_RELEASE_IOS_ANDROID_BIOMETRICS_DEFAULT = '7.38.0';
export const VERSION_RELEASE_IOS_ANDROID_BIOMETRICS_VN = '12.54.0';
export const VERSION_RELEASE_IOS_ANDROID_WAL_ID_MY = '7.45.0';
export const VERSION_RELEASE_IOS_ANDROID_CHANGE_PASSWORD_ID_MY = '7.59.0';
export const VERSION_RELEASE_IOS_ANDROID_PH = '7.68.0';
export const VERSION_RELEASE_QUICK_LOGIN_DEFAULT = '7.69.0';
